"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 700,
      'fontSize': 100,
      'letterSpacing': 0,
      'lineHeightPx': 100,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1247,
        'y': -453,
        'width': 900,
        'height': 100
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 40,
      'letterSpacing': 0,
      'lineHeightPx': 48,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1247,
        'y': -384,
        'width': 900,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'link1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 11,
      'letterSpacing': 1.649999976158142,
      'lineHeightPx': 15,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1341,
        'y': -167,
        'width': 109,
        'height': 15
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': -453,
        'width': 708,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': -390,
        'width': 708,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'link1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 11,
      'letterSpacing': 1.649999976158142,
      'lineHeightPx': 15,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': -180,
        'width': 109,
        'height': 15
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1168,
        'y': -485,
        'width': 327,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1168,
        'y': -422,
        'width': 327,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'link1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 11,
      'letterSpacing': 1.649999976158142,
      'lineHeightPx': 15,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1168,
        'y': -250,
        'width': 87,
        'height': 15
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  }
};
exports.default = _default;